class ClientEditFormService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;

        this.industryCodes = undefined;
        this.industryCodeMap = {};
        this.industryCodeIdMap = {};

        this.surveyTemplates = undefined;
    }

    generateIndustryCodeMappings(industryCodes) {
        for (let industryCode of industryCodes) {
            this.industryCodeMap[industryCode.code] = industryCode;
            this.industryCodeIdMap[industryCode.id] = industryCode;
        }
    }

    /***
     * Fetches the mappings for all of the available NAICS industry codes to their respective industry names.
     *
     * If the codes have already been fetched once, then we return the locally stored version, since they are
     * unlikely to change.
     *
     * Also generates two mapping objects that are used on the Client Edit form page. One allows for looking up the
     * details about an IndustryCode using its code, while the other allows for looking one up by its id.
     *
     * @returns {Promise | array}
     */
    getIndustryCodes() {
        if (this.industryCodes !== undefined) {
            return this.industryCodes;
        }
        return this.$http.get(`${this.appConfig.apiUrl}/industry-codes/`)
            .then((successResponse) => {
                this.industryCodes = successResponse.data;
                this.generateIndustryCodeMappings(this.industryCodes);
                return this.industryCodes;
            });
    }

     /***
     * Fetches a list of all Survey Templates.
     *
     * @returns {Promise}
     */
    getSurveyTemplates() {
        if (this.surveyTemplates !== undefined) {
            return this.surveyTemplates;
        }
        return this.$http.get(`${this.appConfig.apiUrl}/survey-templates/`)
            .then((successResponse) => {
                this.surveyTemplates = successResponse.data;
                return this.surveyTemplates;
            });
    }

    /***
     * Update the given client.
     *
     * @param clientId          the ID of the client being updated.
     * @param data              an object containing all of the updated values for this Facility.
     *
     * @returns {Promise}
     */
    updateClient(clientId, data) {
        return this.$http.patch(`${this.appConfig.apiUrl}/clients/${clientId}/`, data);
    }

    /***
     * Get all of the available Client Groups.
     */
    getGroups() {
        return this.$http.get(`${this.appConfig.apiUrl}/groups/`)
            .then((successResponse) =>  successResponse.data);
    }

}

export default ClientEditFormService;


// WEBPACK FOOTER //
// ./app/components/client-edit/client-edit-form/client-edit-form-service.js